import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ReactionStatus } from '../types';
var compareEmojiId = function compareEmojiId(l, r) {
  return l.localeCompare(r);
};
var sortByRelevance = function sortByRelevance(a, b) {
  if (a.count > b.count) {
    return -1;
  } else if (a.count < b.count) {
    return 1;
  } else {
    return compareEmojiId(a.emojiId, b.emojiId);
  }
};
var sortByPreviousPosition = function sortByPreviousPosition(reactions) {
  var indexes = reactions.reduce(function (map, reaction, index) {
    map[reaction.emojiId] = index;
    return map;
  }, {});
  var getPosition = function getPosition(_ref) {
    var emojiId = _ref.emojiId;
    return indexes[emojiId] === undefined ? reactions.length : indexes[emojiId];
  };
  return function (a, b) {
    return getPosition(a) - getPosition(b);
  };
};
export var readyState = function readyState(reactions) {
  return {
    status: ReactionStatus.ready,
    reactions: reactions.filter(function (reaction) {
      return reaction.count > 0;
    })
  };
};
export var byEmojiId = function byEmojiId(emojiId) {
  return function (reaction) {
    return reaction.emojiId === emojiId;
  };
};
export var addOne = function addOne(reaction) {
  return _objectSpread(_objectSpread({}, reaction), {}, {
    count: reaction.count + 1,
    reacted: true
  });
};
export var removeOne = function removeOne(reaction) {
  return _objectSpread(_objectSpread({}, reaction), {}, {
    count: reaction.count - 1,
    reacted: false
  });
};
export var updateByEmojiId = function updateByEmojiId(emojiId, updater) {
  return function (reaction) {
    return reaction.emojiId === emojiId ? updater instanceof Function ? updater(reaction) : updater : reaction;
  };
};
export var getReactionsSortFunction = function getReactionsSortFunction(reactions) {
  return reactions && reactions.length ? sortByPreviousPosition(reactions) : sortByRelevance;
};
export var flattenAris = function flattenAris(a, b) {
  return a.concat(b);
};
export function isRealErrorFromService(errorCode) {
  // we don't count 401 or 403 as a real error from services
  return !errorCode || !(errorCode === 401 || errorCode === 403);
}